export interface TitleConfig {
  suffix?: string;
}
